// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    RESET_CLAIM_SELECTED_DEALERS: 'RESET_CLAIM_SELECTED_DEALERS',
    RESET_LABOR_RATE_DEALERS_FILTERS: 'RESET_LABOR_RATE_DEALERS_FILTERS',
    SET_LABOR_RATE_COUNT: 'SET_LABOR_RATE_COUNT',
    SET_LABOR_RATE_DEALERS: 'SET_LABOR_RATE_DEALERS',
    UPDATE_LABOR_RATE_DEALERS_FILTERED: 'UPDATE_LABOR_RATE_DEALERS_FILTERED',
    UPDATE_LABOR_RATE_DEALERS_FILTER_BY: 'UPDATE_LABOR_RATE_DEALERS_FILTER_BY',
    UPDATE_LABOR_RATE_DEALERS_SORT_BY: 'UPDATE_LABOR_RATE_DEALERS_SORT_BY',
    UPDATE_LABOR_RATE_DEALERS_SORT_DIRECTION: 'UPDATE_LABOR_RATE_DEALERS_SORT_DIRECTION',
    UPDATE_SELECTED_ALL_DEALER_ACCOUNTS: 'UPDATE_SELECTED_ALL_DEALER_ACCOUNTS',
    UPDATE_SELECTED_DEALER_ACCOUNTS: 'UPDATE_SELECTED_DEALER_ACCOUNTS'
});



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/actions-list.js